var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"dropdown-submenu"},[_c('a',{staticClass:"dropdown-item"},[_c('span',[_vm._t("button-content",function(){return [_vm._v("Submenu button")]})],2),_c('b-icon-chevron-right')],1),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }